// Scroll function to smoothly scroll to a given section id
const scrollToSection = (id, position = "start") => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: position });
};

export default scrollToSection;